import { render, staticRenderFns } from "./bsp-mask.vue?vue&type=template&id=76e4bcc6&scoped=true&"
import script from "./bsp-mask.vue?vue&type=script&lang=js&"
export * from "./bsp-mask.vue?vue&type=script&lang=js&"
import style0 from "./bsp-mask.vue?vue&type=style&index=0&id=76e4bcc6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e4bcc6",
  null
  
)

export default component.exports